module.exports = __webpack_public_path__ + "img/jl_logo_wgq.a75591f7.png";